class ServiceQuestion {
    assistanceServiceId: number;
    questionId: number;

    constructor() {
        this.assistanceServiceId = 0;
        this.questionId = 0;
    }
}

export default ServiceQuestion;